import { Settings } from 'core/hooks/useSettings'

export const isDev =
  process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'test'
export const isStage = process.env.REACT_APP_API_BASE_URL.includes('stage')
export const isPR = process.env.REACT_APP_API_BASE_URL.includes('pr-')
export const isProd =
  process.env.REACT_APP_API_BASE_URL.includes('api.everlance.com')
export const isTesting = isDev || isStage || isPR

/**
 * @description Default global state (termed settings)
 */
const defaultSettings: Settings = {
  //TODO: refactor structure
  featureFlags: {
    ENABLE_PAY_PERIOD_AI: isTesting,
    ENABLE_EVERLANCE_PAYMENTS: isTesting,
    ENABLE_CHANGELOG: isDev,
    ENABLE_ONBOARDING_M3: isTesting,
    ENABLE_NEXT_PROGRAM: false,
    ENABLE_PAYMENTS_M3: isTesting,
    ENABLE_OUTLIERS_2: isTesting,
    ENABLE_B2C_2: isTesting
  },
  tripDetail: {
    tokenId: '',
    view: 'personal',
    props: {}
  },
  pollingJobs: {
    memberBulkInviteJobId: '',
    memberBatchInviteJobId: '',
    memberBulkUpdateJobId: '',
    memberExportJobId: '',
    payPeriodActionJobId: '',
    payPeriodDownloadJobId: '',
    reportBulkUpdateJobId: '',
    fundingRequestJobId: '',
    downloadSummaryJobId: '',
    importTeamPlacesJobId: '',
    mergeGroupIntegrationId: '',
    downloadMergeManagersJobId: '',
    memberBatchDeleteInviteJobId: '',
    mergePreviewEmployeedJobId: ''
  },
  transactionDetail: {
    tokenId: '',
    view: 'personal',
    props: {}
  },
  inDrawerReport: {
    view: 'report',
    activeId: ''
  },
  memberInDrawerView: {
    view: 'main',
    activeId: '',
    prevReportId: null
  },
  mfa: {
    action: null,
    accountId: null,
    customerToken: null,
    onSuccess: null,
    onClose: null,
    onBack: null,
    continueButtonText: 'Continue',
    language:
      'https://ui.s.unit.sh/resources/2796/languages/113ec906-8c97-424c-b1b0-4803f79a06a3.json', // 13895
    themes: [
      'https://ui.s.unit.sh/resources/2796/themes/2a95c62d-dc5f-4408-a940-58446508d43e.json', // 10530
      'https://ui.s.unit.sh/resources/2796/themes/6b182443-dc8d-4732-a386-3fb0a2c8e9c9.json' // 10535
    ]
  },
  addToReportView: {
    view: 'main',
    activeId: ''
  },
  showWelcomeModal: false,
  inAppView: false,
  reimbursementTabParams: {
    pay_periods: '',
    reports: '',
    fixed: '',
    variable: ''
  },
  tooltipTutorial: {
    sideNavStep: 'account-switcher'
  },
  selectedRemoteFields: [],
  ratingModal: {
    active: false,
    trigger: ''
  },
  fundingModal: {
    show: true
  }
}

export { defaultSettings }
